var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.getModals),function(modal,index){return _c('modal',{key:'modal-' + index,staticClass:"custom_modal",attrs:{"payload":modal}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }